import { faAngleDown as lightAngleDown } from "@jewlr/pro-light-svg-icons/faAngleDown"
import { faAngleUp as lightAngleUp } from "@jewlr/pro-light-svg-icons/faAngleUp"
import loadable from "@loadable/component"
import { usePress } from "@react-aria/interactions"
import PropTypes from "prop-types"
import { Suspense, useRef } from "react"

import withFilters from "areas/collection/hoc/with-filters"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { retry } from "helpers/application"
import useHandleOutsideClick from "helpers/use-handle-outside-click"

const SortFilter = loadable(() => retry(() => import("./sort-filter")), {
  ssr: false,
})

const InternalSortMenu = ({
  currentSortOption,
  loading,
  openedSort,
  toggleSort,
}) => {
  const sortMenuRef = useRef()
  const { pressProps } = usePress({
    isDisabled: !!loading,
    onPress: () => toggleSort(!openedSort),
  })

  useHandleOutsideClick({
    enabled: openedSort,
    onOutsideClick: () => toggleSort(false),
    ref: sortMenuRef,
  })

  return (
    <nav aria-label="Sort by" className="relative" ref={sortMenuRef}>
      <Button
        aria-expanded={openedSort}
        aria-haspopup="listbox"
        className="px-4"
        data-cy="collection-sort-button"
        id="collection-sort-button"
        size="sm"
        variant="tertiary"
        {...pressProps}
      >
        Sort by:{" "}
        {currentSortOption && (
          <strong className="ml-4">{currentSortOption.label}</strong>
        )}
        <FontAwesomeIcon
          className="ml-6 align-text-bottom"
          icon={openedSort ? lightAngleUp : lightAngleDown}
        />
      </Button>
      {typeof window !== "undefined" && openedSort && (
        <Suspense fallback={<div />}>
          <SortFilter />
        </Suspense>
      )}
    </nav>
  )
}

InternalSortMenu.propTypes = {
  currentSortOption: PropTypes.object,
  loading: PropTypes.string,
  openedSort: PropTypes.bool,
  sortMenu: PropTypes.object,
  toggleSort: PropTypes.func,
}

const SortMenu = withFilters(InternalSortMenu)

export default SortMenu
